import { GET_PRIMARY_NODE } from '../actions/action_types';

const initialState = {
  primaryNodes: [],
};
export const EEReportsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_PRIMARY_NODE:
      return Object.assign({}, state, {
        primaryNodes: action.payload,
      });
    default:
      return state;
  }
};
